import React, { useState, useEffect  } from 'react'
import {
  Chart as ChartJs,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import moment from 'moment';
import 'moment/locale/es';
import axios from 'axios'
import {collection, getDocs, addDoc, query} from 'firebase/firestore';
import db from "../../config/firebase";

ChartJs.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const ClientsGraphics = () => {

  const [chartData, setChartData] = useState({
    datasets:[]
  })

  const [chartOptions, setChartOptions] = useState({})

  const [dataList, setDataList] = useState([])

  useEffect( () => {

    const getMonths = ( monthsToSubtract=0 ) => {
      return moment().subtract(monthsToSubtract, 'months').format('MMMM')
    }

    setChartOptions({
      responsive: true,
      plugins: {
        legend: {
          position: "top"
        },
        title: {
          display: true,
          text: 'Clientes Nuevos'
        }
      }
    })

    const petition = async () => {

      const q = query(collection(db, "client"));
      const querySnapshot = await getDocs(q);
      let clientArray = [];
      querySnapshot.forEach((doc) => {
        clientArray.push(doc.data());
      });
      addData(clientArray);
    }

    const addData = data => {
      let clientsFiltereds = []
      for( let i=4; i >= 0; i-- ){
        clientsFiltereds = [...clientsFiltereds, data.filter( client => moment(client.actionDate).format('MMMM') == getMonths(i) ).length]
      }

      setDataList(clientsFiltereds)
    }

    petition();

  },[] )

  useEffect( () => {

    const getMonths = ( monthsToSubtract=0 ) => {
      return moment().subtract(monthsToSubtract, 'months').format('MMMM')
    }

    const mappingMonths = () => {
      let monthsCant = []
      for( let i=4; i >= 0; i-- ){
        monthsCant = [...monthsCant, getMonths(i)]
      }

      return monthsCant
    }

    const getChartData = ( ) => {
      return dataList
    }

    setChartData({
      labels: mappingMonths(),
      datasets: [
        {
          label: 'Clientes Nuevos',
          data: getChartData(),
          borderColor: 'rgb(53, 162, 235)',
          backgroundColor: '#53ca98'
        }
      ]
    })

    
  }, [dataList])

  return (
    <>
     <Bar options={chartOptions} data={chartData} />
    </>
  )
}

export default ClientsGraphics